import { useEffect, useRef } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { locationSheetAnswered } from '../state/geoFence.slice';
import { requestLocationPermission } from '../utils/locationPermission';

function GeoFenceBottomSheet({ close }: BottomSheetExtendedProps) {
  const dispatch = useDispatch();
  const isAnsweredRef = useRef(false);

  const handleStartPlaying = async () => {
    isAnsweredRef.current = true;
    close();

    // Triggered by the tap, so browsers show the prompt rather than a quiet one
    const permission = await requestLocationPermission();

    dispatch(locationSheetAnswered(permission));
  };

  useEffect(
    () => () => {
      if (!isAnsweredRef.current) {
        dispatch(locationSheetAnswered('later'));
      }
    },
    [dispatch],
  );

  return (
    <Box flexDirection="column" gap="space-400">
      <Image
        name="common.geoFence"
        width={140}
        height={140}
        alignSelf="center"
      />

      <Text
        variant="h6"
        color="darkSurfacePrimary"
        locNS="geoFence"
        locKey="titleText"
        textAlign="center"
      />

      <Button
        variant="primary"
        locNS="geoFence"
        locKey="startPlayingCta"
        onPress={handleStartPlaying}
      />
    </Box>
  );
}

export default GeoFenceBottomSheet;
